import React, { createContext, useState } from "react";

// Create two context:
// UserContext: to query the context state
// UserDispatchContext: to mutate the context state
const mapContext = createContext(undefined);

// A "provider" is used to encapsulate only the
// components that needs the state in this context
function MapProvider({ children }) {
	const [map, setMap] = useState(null);
	const [mapLoaded, setMapLoaded] = useState(false);
	// const [mapBounds, setMapBounds] = useState(null);
	const [popupContent, setPopupContent] = useState([]);
	const [rulerObject, setRulerObject] = useState(null);
	const [rulerState, setRulerState] = useState(false);
	// const [count, setCount] = useState(0);
	// const [lngLat, setLngLat] = useState({ lng: null, lat: null });

	const Provider = mapContext.Provider;

	return (
		<Provider
			value={{
				map,
				setMap,
				mapLoaded,
				setMapLoaded,
				popupContent,
				setPopupContent,
				rulerObject,
				setRulerObject,
				rulerState,
				setRulerState
			}}
			>
			{children}
		</Provider>
	);
}

export { MapProvider, mapContext };
